import React, { FC } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import ImagePreviewThumbnail from '../../../sharedModules/imagePreview/ImagePreviewThumbnail';

interface ImageGalleryModalProps {
  open: boolean;
  onClose: () => void;
  images: any[];
  label: string;
}

const ImageGalleryModal: FC<ImageGalleryModalProps> = ({ open, onClose, images, label }) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        {label} - All Images
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          {images.map((image, index) => (
            <Grid item xs={12} sm={6} md={4} key={`gallery-${index}`}>
              <ImagePreviewThumbnail image={image} altText={`${label} Image ${index + 1}`} />
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ImageGalleryModal;
